import React, { Component, Fragment } from "react";

import UpdateItem from "./UpdateItem";

class UpdateList extends Component {
  onClick(id, url) {
    const { push, actionCenterClick } = this.props;
    actionCenterClick(id, push(url));
  }

  render() {
    if(this.props.items.length === 0) return <div />;

    return (
      <Fragment>
        <section className="cardTitle _leftAligned">Updates</section>
        {
          this.props.items.map((item) => {
            return (
              <UpdateItem
                key={item.id}
                item={item}
                onClick={(url) => { this.onClick(item.id, url) }}
              />
            );
          })
        }
      </Fragment>
    );
  };
}

export default UpdateList;



// WEBPACK FOOTER //
// ./src/features/notifications/components/UpdateList.js